export default {"src":"https://web.cdn.greenlight.com/2.1328.0/_next/static/media/icon-bars.f3aa50e7.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};